import { useEffect, useState } from "react";
import { getFormData } from "../../../common";
import { deleteComplexV3, updateComplexEducationV3, updateComplexEvaluationV3, updateComplexLivingAreaV3, updateComplexTransportV3 } from "../../../repository/RealEstateRepository";
import { Grade, OnOff } from "../molecule/Evaluation";
import { RealEstateMap } from "./";

const ComplexDetail = (props) => {
  const { complex, frontYards, livingAreas, educations, goBack } = props;
  const { complexStats, complexTransport, complexEducation, complexEvaluation } = props;

  useEffect(() => {
  }, [complex]);

  return (<>
    <ComplexDetailInfo goBack={goBack} complex={complex} complexStats={complexStats} />

    <br />
    <div className="text-left"><h4>생활권</h4></div>
    <ComplexDetailRegion complex={complex} frontYards={frontYards} livingAreas={livingAreas} />

    <br />
    <div className="text-left"><h4>교통</h4></div>
    <ComplexDetailTransport complex={complex} complexTransport={complexTransport} />

    <br />
    <div className="text-left"><h4>학군</h4></div>
    <ComplexDetailEducation complex={complex} complexEducation={complexEducation} educations={educations} />

    <br />
    <div className="text-left"><h4>커뮤니티</h4></div>
    <ComplexDetailEvaluation complex={complex} complexEvaluation={complexEvaluation} />
  </>);
};

/** Info */

const ComplexDetailInfo = (props) => {
  const { complex, complexStats, goBack } = props;
  const [openComplexMap, setOpenComplexMap] = useState(false);
  const [openComplexPyeong, setOpenComplexPyeong] = useState(false);

  const onClickOpenMap = (e) => {
    e.preventDefault();
    setOpenComplexMap(true);
  };

  const onClickOpenComplexPyeong = (e) => {
    e.preventDefault();
    setOpenComplexPyeong(true);
  };

  const onClickDelete = (e) => {
    e.preventDefault();
    const answer = window.confirm("Are you sure?");
    if (answer) {
      deleteComplexV3({ id: complex.id }, () => {
        window.Toast.info("Complex Deleted!");
        goBack();
      });
    }
  };

  return (<>
    <div className="row">
      <div className="col-12 text-left">
        <h3 className="in-bl">{complex.name}</h3>
        &nbsp;{!openComplexPyeong && <Btn onClick={onClickOpenComplexPyeong} icon="bi-arrows-expand" />}
        &nbsp;{!openComplexMap && <Btn onClick={onClickOpenMap} icon="bi-map" />}
        &nbsp;{<Btn theme="btn-outline-danger" onClick={onClickDelete} icon="bi-x-lg" />}
      </div>
    </div>

    <div className="row text-left">
      <div className="col-3 col-lg-1">연식</div>
      <div className="col-9 col-lg-11">{complex.approvedYear}년 - {complex.age}년차 / <ComplexDetailInfoStats complex={complex} complexStats={complexStats} /></div>
    </div>
    <div className="row text-left">
      <div className="col-3 col-lg-1">세대수</div>
      <div className="col-9 col-lg-11">{complex.totalHouseholdCount.toLocaleString("ko-KR")}세대(총{complex.totalDongCount}개동) / 임대:{complex.totalLeaseHouseholdCount.toLocaleString("ko-KR")}</div>
    </div>
    <div className="row text-left">
      <div className="col-3 col-lg-1">공간</div>
      <div className="col-9 col-lg-11">용적률:{complex.batlRatio}% / 건폐율:{complex.btlRatio}%</div>
    </div>
    <div className="row text-left">
      <div className="col-3 col-lg-1">건설사</div>
      <div className="col-9 col-lg-11">{complex.constructionCompany}</div>
    </div>

    {openComplexPyeong && (<>
      <br />
      {complex.complexPyeongs.map(v => (
        <div key={v.name} className="row text-left">
          <div className="col-4 col-lg-3 col-lg-2">{v.name} ({v.householdCount})</div>
          <div className="col-4 col-lg-3 col-lg-2">{window.Math.floor(v.supplyPyeong)}평 ({window.Math.floor(v.exclusiveArea)})</div>
          <div className="col-4 col-lg-3 col-lg-2">방:{v.roomCount},화:{v.bathroomCount},{v.entranceType.substr(0, 2)}</div>
        </div>))}
    </>)}

    {openComplexMap && (<>
      <br />
      <div className="row">
        <div className="col-12">
          <Wrap heightRatio="60%">
            <RealEstateMap
              height="100%"
              markers={[{
                icon: {
                  content: [`<img src="https://docs.google.com/drawings/d/e/2PACX-1vTpEOMmFzq62_uT6ar2E7_ov3-P3cD8uhMdVnCe_QAsRsCaDdcf9Dw-Z_hCKZNRO3PTQJ5fQHq3gca_/pub?w=50&h=50" style="position:absolute;left:-25px;top:-50px;" />`].join("")
                },
                latitude: complex.latitude,
                longitude: complex.longitude
              }]}
              default={{
                center: { latitude: complex.latitude, longitude: complex.longitude },
                zoom: 16
              }}
            />
          </Wrap>
        </div>
      </div>
    </>)}
  </>);
};

const ComplexDetailInfoStats = (props) => {
  const { complexStats, complex } = props;

  return complexStats && (<>
    <span>
      {complexStats.newComplexCount}개{complex.age <= 10 ? "(v)" : ""}
      -{complexStats.semiNewComplexCount}개{complex.age > 11 && complex.age <= 25 ? "(v)" : ""}
      -{complexStats.oldComplexCount}개{complex.age > 25 ? "(v)" : ""}
    </span>
  </>);
};

/** Region */

const ComplexDetailRegion = (props) => {
  const { complex, frontYards, livingAreas } = props;

  const onChangeLivingArea = (e) => {
    const newLivingAreaId = e.target.value;
    if (newLivingAreaId) {
      updateComplexLivingAreaV3({ id: complex.id, livingAreaId: newLivingAreaId }, () => {
        window.Toast.info("LIVING AREA CHANGED");
      });
    }
  };

  return (<>
    <div className="row">
      <div className="col-6 col-lg-3 text-left">
        <RegionSelect
          items={frontYards.map(v => ({ key: v.id, value: v.name }))}
          defaultValue={complex.livingArea.frontYard.id} />
      </div>
      <div className="col-6 col-lg-3 text-left">
        <RegionSelect
          items={livingAreas.map(v => ({ key: v.id, value: v.name }))}
          defaultValue={complex.livingArea.id}
          onChange={onChangeLivingArea} />
      </div>
    </div>
  </>);
}

/** Transport */

const ComplexDetailTransport = (props) => {
  const { complex, complexTransport } = props;
  const regions = [
    { key: "gangnam", value: "강남" },
    { key: "central", value: "종로" },
    { key: "yeouido", value: "여의도" },
    { key: "magok", value: "마곡" },
    { key: "dmc", value: "DMC" },
    { key: "industry", value: "산업" },
    { key: "pangyo", value: "판교" }];

  const onBlurTransportTime = (e) => {
    const formData = getFormData(e.target.form);
    let transportData = {};
    regions.forEach(region => {
      const travelKey = `${region.key}-travelTimeMinutes`;
      const walkingKey = `${region.key}-walkingTimeMinutes`;
      const intervalKey = `${region.key}-intervalMinutes`;
      const transferKey = `${region.key}-transferCount`;
      const intervalMinutes = formData[intervalKey];
      const walkingTimeMinutes = formData[walkingKey];
      const travelTimeMinutes = formData[travelKey];
      const transferCount = formData[transferKey];
      const hasNoValues = (intervalMinutes === undefined && walkingTimeMinutes === undefined && travelTimeMinutes === undefined && transferCount === undefined);
      if (!hasNoValues)
        transportData[region.key] = { travelTimeMinutes, walkingTimeMinutes, intervalMinutes, transferCount };
    });

    const invalidCount = Object.keys(transportData).map(k => transportData[k]).filter(v => v.intervalMinutes === undefined || v.walkingTimeMinutes === undefined || v.travelTimeMinutes === undefined || v.transferCount === undefined).length;
    if (Object.keys(transportData).length && !invalidCount) {
      transportData.complexId = formData.complexId;
      updateComplexTransportV3(transportData, () => window.Toast.info("COMPLEX_TRANSPORT_UPDATED."));
    }
  }

  return (<>
    {complexTransport != null && (<form>
      <div className="row">
        {regions.slice(0, 3).map(region => (
          <div className="col-6 col-lg-3" key={region.key}>
            <ComplexDetailTransportItem
              region={region}
              defaultComplexTransport={complexTransport[region.key]}
              onBlurTransportTime={onBlurTransportTime} />
          </div>
        ))}
      </div>
      <div className="row">
        {regions.slice(-4).map(region => (
          <div className="col-6 col-lg-3" key={region.key}>
            <ComplexDetailTransportItem
              region={region}
              defaultComplexTransport={complexTransport[region.key]}
              onBlurTransportTime={onBlurTransportTime} />
          </div>
        ))}
      </div>
      <input type="hidden" name="complexId" value={complex.id} readOnly={true} />
    </form>)}
  </>);
};

const ComplexDetailTransportItem = (props) => {
  const { region, defaultComplexTransport } = props;

  const defaultTravelTimeMinutes = defaultComplexTransport ? defaultComplexTransport.travelTimeMinutes : "";
  const defaultWalkingTimeMinutes = defaultComplexTransport ? defaultComplexTransport.walkingTimeMinutes : "";
  const defaultIntervalMinutes = defaultComplexTransport ? defaultComplexTransport.intervalMinutes : "";
  const defaultTransferCount = defaultComplexTransport ? defaultComplexTransport.transferCount : "";
  const totalTimeMinutes = defaultTravelTimeMinutes > 0 ? defaultTravelTimeMinutes + (defaultIntervalMinutes > 0 ? defaultIntervalMinutes / 2 : 0) : 0;

  const onBlur = (e) => {
    props.onBlurTransportTime(e);
  };

  return (<>
    <div className="text-left">{region.value}&nbsp;{totalTimeMinutes > 0 ? totalTimeMinutes + '분' : ''}</div>
    <div className="input-group input-group-sm" key={region.key} style={{ justifyContent: "center" }}>
      <input style={{}} className="form-control" placeholder="시간" name={`${region.key}-travelTimeMinutes`} defaultValue={defaultTravelTimeMinutes} onBlur={onBlur}></input>
      <input style={{}} className="form-control" placeholder="도보" name={`${region.key}-walkingTimeMinutes`} defaultValue={defaultWalkingTimeMinutes} onBlur={onBlur}></input>
      <input style={{}} className="form-control" placeholder="간격" name={`${region.key}-intervalMinutes`} defaultValue={defaultIntervalMinutes} onBlur={onBlur}></input>
      <input style={{}} className="form-control" placeholder="환승" name={`${region.key}-transferCount`} defaultValue={defaultTransferCount} onBlur={onBlur}></input>
    </div>
  </>);
};

/** Education */

const ComplexDetailEducation = (props) => {
  const { complex, complexEducation, educations } = props;

  const onChangeComplexEducation = (e) => {
    const formData = getFormData(e.target.form);
    updateComplexEducationV3(formData, () => window.Toast.info("COMPLEX_EDUCATION_UPDATED."));
  };

  return (<>
    {complexEducation != null && educations != null && (<form>
      <div className="row">
        <div className="col-12 col-lg-3">
          <div className="text-left">중학교</div>
          <div className="input-group input-group-sm" style={{ justifyContent: "center" }}>
            <select className="form-control" name="middleSchoolId" defaultValue={complexEducation.middleSchool && complexEducation.middleSchool.id} onChange={onChangeComplexEducation}>
              <option value="">선택</option>
              {educations.middleSchools.map(v => (
                <option key={v.id} value={v.id}>{v.name} / {v.score}점 ({v.specializedHeadcount}명)</option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-12 col-lg-3">
          <div className="text-left">학원가</div>
          <div className="input-group input-group-sm" style={{ justifyContent: "center" }}>
            <select className="form-control" name="academyStreetId" defaultValue={complexEducation.academyStreet && complexEducation.academyStreet.id} onChange={onChangeComplexEducation}>
              <option value="">선택</option>
              {educations.academyStreets.map(v => (
                <option key={v.id} value={v.id}>{v.name} / {v.academyCount}개</option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-12 col-lg-3">
          <div className="text-left">초등학교</div>
          <div className="input-group input-group-sm" style={{ justifyContent: "center" }}>
            <select className="form-control" name="elementarySchoolId" defaultValue={complexEducation.elementarySchool && complexEducation.elementarySchool.id} onChange={onChangeComplexEducation}>
              <option value="">선택</option>
              {educations.elementarySchools.map(v => (
                <option key={v.id} value={v.id}>{v.name} / {v.headcount}명</option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-12 col-lg-3"></div>
      </div>
      <input type="hidden" name="complexId" value={complex.id} readOnly={true} />
    </form>)}
  </>);
};

/** ComplexCommunity  */

const ComplexDetailEvaluation = (props) => {
  const { complex, complexEvaluation } = props;

  const onChangeValue = (e, v) => {
    const formData = getFormData(e.target.form);
    updateComplexEvaluationV3(formData, () => window.Toast.info("COMPLEX_EVALUATION_UPDATED."));
  };

  return (<>
    {complexEvaluation != null && (<form>
      <div className="row">
        <div className="col-6 col-lg-3">
          <div className="text-left">주변환경</div>
          <Grade name={"surroundingBuildingGrade"} defaultValue={complexEvaluation.surroundingBuildingGrade} theme="secondary" onChange={onChangeValue} />
        </div>
        <div className="col-6 col-lg-3">
          <div className="text-left">주변상권</div>
          <Grade name={"surroundingStoreGrade"} defaultValue={complexEvaluation.surroundingStoreGrade} theme="secondary" onChange={onChangeValue} />
        </div>
        <div className="col-6 col-lg-3">
          <div className="text-left">외제차</div>
          <Grade name={"foreignCarRate"} defaultValue={complexEvaluation.foreignCarRate} theme="secondary" onChange={onChangeValue} />
        </div>
        <div className="col-6 col-lg-3">
          <div className="text-left">생활수준</div>
          <Grade name={"wealthRate"} defaultValue={complexEvaluation.wealthRate} theme="secondary" onChange={onChangeValue} />
        </div>
      </div>
      <div className="row">
        <div className="col-6 col-lg-3">
          <div className="text-left">언덕</div>
          <Grade name={"hillLevel"} defaultValue={complexEvaluation.hillLevel} theme="secondary" onChange={onChangeValue} />
        </div>
        <div className="col-6 col-lg-3">
          <div className="text-left">동간거리</div>
          <Grade name={"buildingDistance"} defaultValue={complexEvaluation.buildingDistance} theme="secondary" onChange={onChangeValue} />
        </div>
        <div className="col-6 col-lg-3">
          <div className="text-left">조경</div>
          <Grade name={"landscapingGrade"} defaultValue={complexEvaluation.landscapingGrade} theme="secondary" onChange={onChangeValue} />
        </div>
      </div>
      <div className="row">
        <div className="col-6 col-lg-3">
          <Blk>
            <div className="text-left">지하주차장</div>
            <OnOff name={"hasUndergroundParkingLot"} defaultChecked={complexEvaluation.hasUndergroundParkingLot} theme="secondary" onChange={onChangeValue} />
          </Blk>
          <Blk>
            <div className="text-left">주차장연결</div>
            <OnOff name={"hasConnectingParkingLot"} defaultChecked={complexEvaluation.hasConnectingParkingLot} theme="secondary" onChange={onChangeValue} />
          </Blk>
        </div>
        <div className="col-6 col-lg-3">
          <Blk>
            <div className="text-left">주차차단기</div>
            <OnOff name={"hasParkingBreaker"} defaultChecked={complexEvaluation.hasParkingBreaker} theme="secondary" onChange={onChangeValue} />
          </Blk>
          <Blk>
            <div className="text-left">현관보안키</div>
            <OnOff name={"hasEntranceKey"} defaultChecked={complexEvaluation.hasEntranceKey} theme="secondary" onChange={onChangeValue} />
          </Blk>
        </div>
        <div className="col-6 col-lg-3">
          <div className="text-left">도보</div>
          <Grade name={"walkwayGrade"} defaultValue={complexEvaluation.walkwayGrade} theme="secondary" onChange={onChangeValue} />
        </div>
        <div className="col-6 col-lg-3">
          <div className="text-left">도로</div>
          <Grade name={"roadGrade"} defaultValue={complexEvaluation.roadGrade} theme="secondary" onChange={onChangeValue} />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="text-left">메모</div>
          <textarea className={"form-control"} name="memo" defaultValue={complexEvaluation.memo} style={{ minHeight: "4em", lineHeight: 1.0 }} onBlur={onChangeValue} />
          <input type="hidden" name="complexId" value={complex.id} readOnly={true} />
        </div>
      </div>
    </form>)}
  </>);
};

/**
 * ETC
 */

const Blk = (props) => {
  const { width } = props;
  return (<div style={{ display: "inline-block", width: width || "50%" }}>{props.children}</div>);
};

const Btn = (props) => {
  const { icon, onClick, theme } = props;
  return (<button className={`btn btn-sm ${!theme ? "btn-outline-secondary" : theme}`} onClick={onClick}><i className={icon}></i></button>);
};

const RegionSelect = (props) => {
  const { defaultValue, items, onChange } = props;
  return (<>
    {items && items.length > 0 && (
      <select
        className="form-control form-control-sm fluid text-center"
        style={{ display: "inline-block" }}
        defaultValue={defaultValue}
        onChange={onChange}>
        {items.map(v => (<option key={v.key} value={v.key}>{v.value}</option>))}
      </select>
    )}
  </>);
};

const Wrap = (props) => (
  <div className="row" style={{ position: "relative", height: 0, paddingBottom: props.heightRatio || "60%" }}>
    <div className="col" style={{ position: "absolute", left: 0, bottom: 0, right: 0, top: 0 }}>
      {props.children}
    </div>
  </div>
);

export { ComplexDetail };
